import { createSlice } from '@reduxjs/toolkit'

export const allAccountsSlice = createSlice({
    name: 'allAccounts',
    initialState: {},
    reducers: {
        setAllAccounts: (state, action) => {
            return action.payload
        }
    }
})

export const { setAllAccounts } = allAccountsSlice.actions

export const getAllAccounts = (state) => state?.allAccounts

export default allAccountsSlice.reducer